<script>
  import { _ } from './services/i18n'
</script>

<section class="services">
  <h2 id="services">{$_('services.title')}</h2>
  <div class="box project">
    <h3>{$_('services.project')}</h3>
    <p>
      {$_('services.project_title')}
    </p>
  </div>
  <div class="box consulting">
    <h3>{$_('services.consulting')}</h3>
    <p>
      {$_('services.consulting_title')}
    </p>
  </div>
  <div class="box maketing">
    <h3>{$_('services.design')}</h3>
    <p>{$_('services.design_title')}</p>
  </div>
  <div class="box other">
    <h3>
      {$_('services.tech')}
    </h3>
    <ul>
      <li>{$_('services.tech_title1')}</li>
      <li>{$_('services.tech_title2')}</li>
      <li>{$_('services.tech_title3')}</li>
      <li>{$_('services.tech_title4')}</li>
    </ul>
  </div>
</section>

<style>
  h2 {
    padding-top: 5rem;
    font-size: 2rem;
    font-weight: 500;
    position: absolute;
    left: 50%;
    top: 21px;
    transform: translateX(-50%);
  }
  .services {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    width: 100%;
    padding: 12rem 0 6rem 0;
    position: relative;
  }
  .box {
    padding: 1rem;
    height: 350px;
    border-radius: 3px;
    background-clip: content-box;
    background-size: cover;
    background-position: center;
    position: relative;
    background-blend-mode: darken;
    transition: all 300ms ease-in-out;
  }
  .box:hover {
    transform: scale(1.02);
  }
  .box h3,
  .box p,
  .box li {
    color: var(--mainWhite);
    position: relative;
  }
  .box h3 {
    padding: 0.5rem;
  }
  .box p {
    padding: 0 0.5rem;
    line-height: 1.6;
  }
  .box li {
    padding: 0 0.5rem;
    line-height: 1.6;
  }
  .project {
    background-image: linear-gradient(rgb(20, 24, 36), rgb(20, 24, 36, 0.75)),
      url('../assets/projekti.jpg');
  }
  .consulting {
    background-image: linear-gradient(rgb(20, 24, 36), rgb(20, 24, 36, 0.75)),
      url('../assets/konsultēšana.jpg');
  }
  .maketing {
    background-image: linear-gradient(rgb(20, 24, 36), rgb(20, 24, 36, 0.75)),
      url('../assets/maketēšana.jpg');
  }
  .other {
    background-image: linear-gradient(rgb(20, 24, 36), rgb(20, 24, 36, 0.75)),
      url('../assets/druka.jpg');
  }
  @media (max-width: 768px) {
    .services {
      grid-template-columns: 1fr;
      grid-template-rows: repeat(4, 1fr);
      padding-top: 10rem;
      padding-bottom: 2rem;
    }
    .box h3, .box li {
      text-align: center;
    }
    .box p {
      text-align: center;
    }
  }
</style>
